import { Box, Paper, Typography } from '@mui/material'
import { useAlerts } from 'src/lib/alertStore'

interface AlertData {
    id: string
    title: string
    body: string
}

export function AlertToast() {
    const { alerts, removeAlert } = useAlerts() as { alerts: AlertData[], removeAlert: (id: string) => void }

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 20,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                width: '90%',
                maxWidth: 400,
            }}
        >
            {alerts.map(alert => (
                <Paper
                    key={alert.id}
                    elevation={4}
                    sx={{
                        'p': 2,
                        'bgcolor': 'warning.main',
                        'color': 'warning.contrastText',
                        'animation': 'slideIn 0.3s ease-out',
                        '@keyframes slideIn': {
                            from: { opacity: 0, transform: 'translateY(-20px)' },
                            to: { opacity: 1, transform: 'translateY(0)' },
                        },
                    }}
                    onClick={() => removeAlert(alert.id)}
                >
                    <Typography variant="subtitle1" fontWeight={700}>
                        {alert.title}
                    </Typography>
                    <Typography variant="body2">
                        {alert.body}
                    </Typography>
                </Paper>
            ))}
        </Box>
    )
}
